import { useEffect, useState } from "react";
import SessionScheduler from "../../components/session-scheduler/sessionScheduler";
import { ReEvent } from "../../interfaces/types";
import { useCustomThemeContext } from "../../providers/customThemeProvider";
import { useParams } from "react-router-dom";
import { useEventContext } from "../../providers/EventProvider";

export default function SessionSchedulerPage() {
  // Extract the updateTheme function from the custom theme context
  const { updateTheme } = useCustomThemeContext();
  const { eventId } = useParams();
  const {getEventById} = useEventContext();
  const [event, setEvent] = useState<ReEvent>();

  // Use useEffect to update the theme when the component mounts
  useEffect(() => {
    if (eventId) {
      const eventFromNav = getEventById(eventId);
      if (eventFromNav) {
        setEvent(eventFromNav);
        updateTheme(eventFromNav);
      }
    }
    else updateTheme();
  }, [eventId, getEventById]);

  return (<>
    {event && <SessionScheduler event={event} />}
    {!event && <div>Loading event...</div>}
  </>);
}
